"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Observation_Component = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Ratio_1 = require("./RTTI_Ratio");
var RTTI_SampledData_1 = require("./RTTI_SampledData");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Observation_ReferenceRange_1 = require("./RTTI_Observation_ReferenceRange");
exports.RTTI_Observation_Component = t.recursion('IObservation_Component', function () {
    return t.intersection([
        t.type({
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            valueQuantity: RTTI_Quantity_1.RTTI_Quantity,
            valueCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            valueString: t.string,
            _valueString: RTTI_Element_1.RTTI_Element,
            valueBoolean: t.boolean,
            _valueBoolean: RTTI_Element_1.RTTI_Element,
            valueInteger: t.number,
            _valueInteger: RTTI_Element_1.RTTI_Element,
            valueRange: RTTI_Range_1.RTTI_Range,
            valueRatio: RTTI_Ratio_1.RTTI_Ratio,
            valueSampledData: RTTI_SampledData_1.RTTI_SampledData,
            valueTime: t.string,
            _valueTime: RTTI_Element_1.RTTI_Element,
            valueDateTime: t.string,
            _valueDateTime: RTTI_Element_1.RTTI_Element,
            valuePeriod: RTTI_Period_1.RTTI_Period,
            dataAbsentReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            interpretation: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            referenceRange: t.array(RTTI_Observation_ReferenceRange_1.RTTI_Observation_ReferenceRange)
        })
    ]);
});
//# sourceMappingURL=RTTI_Observation_Component.js.map